import PropTypes from 'prop-types'
import PrimaryButton from '../PrimaryButton'
import { buildQueryString, generateRandomKey } from '../../../common/utils'
import Img from '../Img'
import { useLeadId } from '../../../common/lead-id'
import { useRouter } from 'next/router'
import { useMemo } from 'react'

const ResolveDebt = ({ data }) => {
  const leadId = useLeadId()
  const { query: baseQuery } = useRouter()

  let query = useMemo(
    () => buildQueryString(baseQuery, leadId),
    [baseQuery, leadId]
  )

  return (
    <div
      className="flex flex-col border-t-4 border-blue-600 bg-gray-130 px-8 py-6 text-left lg:px-5"
      data-testid="resolve-debt"
      id="resolve-debt-consolidation-state-cta"
    >
      <h2 className="mb-3 text-2xl text-blue-700">{data.title}</h2>
      <p className="text-sm font-semibold text-gray-510">{data.description}</p>
      <ul className="mt-3">
        {data.options.map((item) => (
          <li
            key={generateRandomKey()}
            className="flex items-center py-1 text-sm font-normal text-gray-510"
          >
            <div className="pr-1 pt-1">
              <Img
                dataTestId="resolve-debt-item"
                alt="checkIcon"
                src="/next-assets/icons/check-green-icon.svg"
                className="h-3 w-3"
                styles={{ position: 'relative' }}
              />
            </div>
            {item}
          </li>
        ))}
      </ul>
      <div className="mt-6 flex justify-center">
        <PrimaryButton
          sectionTitle={data.title}
          title={data.buttonTitle}
          href={`${data.buttonUrl}?${query}`}
          className="w-full bg-blue-300 py-3 text-center text-lg font-normal text-black-base lg:w-64"
          type="nocta"
        />
      </div>
    </div>
  )
}

ResolveDebt.propTypes = {
  data: PropTypes.object.isRequired,
}
export default ResolveDebt
